import { supabase } from '../lib/supabase';

export type TipoAto =
  | 'portaria'
  | 'decreto'
  | 'lei'
  | 'lei_complementar'
  | 'resolucao'
  | 'instrucao_normativa'
  | 'edital'
  | 'outros';

export const TIPO_ATO_LABEL: Record<TipoAto, string> = {
  portaria: 'Portaria',
  decreto: 'Decreto',
  lei: 'Lei',
  lei_complementar: 'Lei Complementar',
  resolucao: 'Resolução',
  instrucao_normativa: 'Instrução Normativa',
  edital: 'Edital',
  outros: 'Outros',
};

export const TIPOS_ATO_LISTA: TipoAto[] = [
  'portaria', 'decreto', 'lei', 'lei_complementar',
  'resolucao', 'instrucao_normativa', 'edital', 'outros',
];

export interface AtoListaItem {
  id: string;
  numero_interno: string;
  numero_publicado: string | null;
  tipo_ato: TipoAto | null;
  titulo: string;
  ementa: string | null;
  autoridade_nome: string | null;
  autoridade_cargo: string | null;
  data_publicacao: string | null;
  revogado: boolean;
  revogado_por_numero: string | null;
  altera_numero: string | null;
  alterado_por_numero: string | null;
  pdf_url: string | null;
}

export interface AtoDetalhe extends AtoListaItem {
  corpo: string | null;
  data_revogacao: string | null;
  motivo_revogacao: string | null;
  estabelecimento_nome: string | null;
  pdf_gerado_em: string | null;
}

export const atosOficiaisService = {
  async listar(estabelecimentoId: string, ano?: number, tipo?: string, busca?: string): Promise<{ ano: number; atos: AtoListaItem[] }> {
    const { data, error } = await supabase.rpc('atos_oficiais_listar_publicos', {
      p_estabelecimento_id: estabelecimentoId,
      p_ano: ano ?? null,
      p_tipo_ato: tipo ?? null,
      p_busca: busca ?? null,
    });
    if (error) throw error;
    const r = data as { ano: number; atos: AtoListaItem[] };
    return { ano: r.ano, atos: r.atos ?? [] };
  },

  async buscar(documentoId: string): Promise<AtoDetalhe | { erro: string }> {
    const { data, error } = await supabase.rpc('ato_oficial_buscar_publico', {
      p_documento_id: documentoId,
    });
    if (error) throw error;
    return data as AtoDetalhe | { erro: string };
  },
};
